import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RolAccessComponent } from '../rolAccess/rolAccessList/rolAccess.component';
import { NgModule } from '@angular/core';
import { AccessService } from '../../security/Accesses/shared/access.service';
import { RolAccessService} from '../rolAccess/shared/rolAccess.service'
import { RolAccessRoutingModule,ROUTABLE_COMPONENTS} from '../rolAccess/rolAccess.routing';
import { MatButtonModule, MatInputModule, MatCheckboxModule, MatSlideToggleModule, MatTableModule,MatFormFieldModule,MatPaginatorModule } from '@angular/material';
import { FabButtonGroupModule } from '../../../shared/fabbuttongroup/fabbuttongroup.module';
import { SectionBarModule } from '../../../shared/sectionbar/sectionbar.module';
import {rolAccessOutComponent} from'../rolAccess/rolAccessOut.component';

//ccontrols
import { TitlebarModule } from '../../../shared/titlebar/titlebar.module';
import { HeaderModule } from '../../../shared/header/header.module';
import { LoaderModule } from '../../../shared/loader/loader.module';
import { SnackbarModule } from '../../../shared/snackbar/snackbar.module';


@NgModule({
    imports: [
      BrowserModule,
      FormsModule, ReactiveFormsModule,
      RolAccessRoutingModule,
      MatTableModule, MatCheckboxModule, MatButtonModule, MatInputModule, MatSlideToggleModule,
      MatFormFieldModule,MatPaginatorModule,
      FabButtonGroupModule, SectionBarModule,
      TitlebarModule, HeaderModule, LoaderModule, SnackbarModule
    ],
    entryComponents: [],
    exports: [],
    declarations: [

        RolAccessComponent,
        rolAccessOutComponent,
        ROUTABLE_COMPONENTS
    ],
    providers: [AccessService,RolAccessService],
    bootstrap: []
})
export class RolAccessModule {
}
